export const dataUsuarioVacio = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  errorDescripcion: "",
  cliCodigoCore: "", //agregado cuando se necesito hacer publica la pagina de confirmacion final de pago
  userIsLoggedIn: false,
  isSuscriptor: false,
  sso: false,
  jwtDecoded: null,
};

export const empresa = "AIGMEX";

///---------Pymes-----------
export const totales = {
  baseImponible: 0,
  derechoEmision: 0,
  impCampesino: 0,
  iva: 0,
  primaNeta: 0,
  primaTotal: 0,
  superintendencia: 0,
};

export const tipoCotizacion = [
  { name: "Seleccione el tipo", id: "" },
  { name: "Edificio Completo", id: "completo" },
  { name: "Solo áreas comunales", id: "areasComunales" },
];

export const arraySiniestralidad = [
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0,
  },
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0,
  },
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0,
  },
];
export const vehiculoConst = {
  marcaCodigo: "",
  marcaEd: false,
  marcaNombre: "",
  modeloEd: false,
  modeloCodigo: "",
  anioEd: false,
  anio: "",
  modeloNombre: "",
  placa: "",
  placaEd: false,
  motor: "",
  motorEd: false,
  chasis: "",
  chasisEd: false,
  colorCodigo: "",
  colorNombre: "",
  colorEd: false,
  procedenciaCodigo: "",
  procedenciaNombre: "",
  procedenciaEd: false,
  categoriaCodigo: "",
  categoriaEd: false,
  categoriaNombre: "",
};

export const Ramos = {
  rcandina: "rcandina",
};
